module.exports = __webpack_public_path__ + "static/media/momo_uta.b9c93b1f.png";